<!-- Container-fluid starts-->
<div class="container-fluid">
  <div class="row">

    <!-- Filter -->
    <div class="col-lg-2 col-md-12 col-12">
      <div class="card">
        <div class="card-header">
          <h5>Filter</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 col-md-3 col-6 form-group">
              <label class="form-label">Status</label>
              <ng-multiselect-dropdown
              [placeholder]="'--status--'"
              [settings]="dropdownSettingsStatus"
              [data]="dropdownListStatus"
              [(ngModel)]="selectedItemsStatus"
              (onSelect)="onItemSelect($event)"
              (onSelectAll)="onSelectAll($event)"
              >
              </ng-multiselect-dropdown>
            </div>

            <div class="col-lg-12 col-md-3 col-6 form-group">
              <label class="form-label">Country</label>
              <ng-multiselect-dropdown
                [placeholder]="'--country--'"
                [settings]="dropdownSettingsCountry"
                [data]="countries"
                [(ngModel)]="selectedItemsCountry"
                (onSelect)="onItemSelectCountry($event)"
                (onSelectAll)="onSelectAllCountry($event)"
                >
              </ng-multiselect-dropdown>
            </div>

            <div class="col-lg-12 col-md-3 col-6 form-group">
              <label class="form-label">Start date</label>
              <input class="form-control" type="date"  max="{{this.DateMax}}" [(ngModel)]="fromDate">
            </div>

            <div class="col-lg-12 col-md-3 col-6 form-group">
              <label class="form-label">End  date</label>
              <input class="form-control digits" type="date"  max="{{this.DateMax}}" [(ngModel)]="toDate">
            </div>
          </div>

          <div class="form-group align-items-center">
              <button class="btn btn-pill btn-sm {{btnColor}}" type="button" placement="top" ngbTooltip="apply filter" (click)="onFilter()" name="btnFilter">
              {{btnName}}</button>
              <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="clear filter" (click)="onClear()" name="btnClear">
                Clear</button>
            </div>
            <!-- <p>from: {{filter.fromDate | date}}</p>
            <p>to: {{filter.toDate | date}}</p>
            <span *ngIf="btnOn"><p *ngFor="let sel of filter.status">{{sel.item_text}}</p></span>
            <span *ngIf="btnOn"><p *ngFor="let sel of filter.country">{{sel.item_id}} {{sel.name}}</p></span> -->

        </div>
      </div>
    </div>

    <div class="col-lg-10 col-md-12 col-12">
      <div class="card">
        <div class="card-body custom-datatable">
          <ngx-datatable
          class='bootstrap'
          [rows]="conversionsData"
          [columnMode]="ColumnMode.flex"
          [headerHeight]="50"
          [footerHeight]="50"
          [rowHeight]="'auto'"
          [externalPaging]="true"
          [count]="page.totalElements"
          [offset]="page.pageNumber"
          [limit]="page.size"
          (page)="setPage($event)"
          [sorts]="[{prop: 'dateUtc', dir: 'desc'}]"
          >
            <ngx-datatable-column name="dateUtc" [flexGrow]="1">
              <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                <span class="myHeader txt-primary" (click)="sort()">Date</span>
               </ng-template>
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row.dateUtc | date:'d/MM/yyyy H:mm' }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="conversionStatus.name" [flexGrow]="1" prop="conversionStatus.name">
              <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                <span class="myHeader txt-primary" (click)="sort()">Status</span>
               </ng-template>
               <ng-template let-row="row" ngx-datatable-cell-template>
                <div *ngIf="row.conversationStatus.name == 'Pending'">
                  <span class="badge badge-warning">{{ row.conversationStatus.name }}</span>
                </div>
                <div *ngIf="row.conversationStatus.name == 'Paid'">
                  {{ row.conversationStatus.name }}
                </div>
                <div *ngIf="row.conversationStatus.name == 'Reverted'">
                  <span class="badge badge-danger">{{ row.conversationStatus.name }}</span>
                </div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="revenue" [flexGrow]="1">
              <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                <span class="myHeader txt-primary" (click)="sort()">Payout</span>
               </ng-template>
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row.revenue | currency }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="country.name" [flexGrow]="1" prop="country.name">
              <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                <span class="myHeader txt-primary" (click)="sort()">Visitor</span>
               </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <i class="flag-icon flag-icon-{{row.country.alpha2Code | lowercase}}"></i>&nbsp;
                  {{row.country.name}}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="referer" [flexGrow]="2">
              <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                <span class="myHeader txt-primary" (click)="sort()">Referer</span>
               </ng-template>
              <ng-template let-row="row" ngx-datatable-cell-template>
                <a href="{{ row.referer }}">{{row.referer}}</a>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="offerName" [flexGrow]="1">
              <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                <span class="myHeader txt-primary" (click)="sort()">Offer</span>
               </ng-template>
              <ng-template let-row="row" ngx-datatable-cell-template>
                <a href="pub/offers/{{ row.offerId }}">{{ row.offerName}}</a>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="contentLockerName" [flexGrow]="1">
              <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                <span class="myHeader txt-primary" (click)="sort()">Locker</span>
               </ng-template>
              <ng-template let-row="row" ngx-datatable-cell-template>
                <a href="pub/gateway/{{ row.contentLockerId }}">{{ row.contentLockerName}}</a>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </div>

  </div>
</div>
<!-- Container-fluid Ends-->
